import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useCategories } from "../context/StoreDataContext";
import ProductCard from "../components/ProductCard";

export default function Catalog() {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [params, setParams] = useSearchParams();
    const { categories } = useCategories();
    const cat = params.get("cat") || "all";

    useEffect(() => {
        setLoading(true);
        const query = cat === "all" ? {} : { category: cat };
        api.get("/products", { params: query })
            .then((r) => setProducts(r.data))
            .finally(() => setLoading(false));
    }, [cat]);

    function selectCat(slug) {
        if (slug === "all") setParams({});
        else setParams({ cat: slug });
    }

    return (
        <div className="px-6 md:px-12 lg:px-20 pt-32 pb-20" data-testid="catalog-page">
            <div className="text-center mb-12">
                <p className="overline">Catálogo</p>
                <h1 className="font-serif text-5xl sm:text-6xl text-charcoal mt-3">
                    Nuestra <span className="italic">colección.</span>
                </h1>
            </div>

            <div className="flex flex-wrap justify-center gap-2 mb-12" data-testid="category-filters">
                <button
                    onClick={() => selectCat("all")}
                    className={`px-5 py-2 rounded-full text-xs tracking-[0.2em] uppercase transition ${
                        cat === "all"
                            ? "bg-rose text-white"
                            : "border border-border-soft text-charcoal hover:border-rose"
                    }`}
                    data-testid="category-filter-all"
                >
                    Todo
                </button>
                {categories.map((c) => (
                    <button
                        key={c.id}
                        onClick={() => selectCat(c.slug)}
                        className={`px-5 py-2 rounded-full text-xs tracking-[0.2em] uppercase transition ${
                            cat === c.slug
                                ? "bg-rose text-white"
                                : "border border-border-soft text-charcoal hover:border-rose"
                        }`}
                        data-testid={`category-filter-${c.slug}`}
                    >
                        {c.name}
                    </button>
                ))}
            </div>

            {loading ? (
                <p className="text-center text-taupe">Cargando piezas...</p>
            ) : products.length === 0 ? (
                <p className="text-center text-taupe italic font-serif text-2xl">
                    Aún no hay piezas en esta categoría.
                </p>
            ) : (
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-6" data-testid="catalog-grid">
                    {products.map((p) => (
                        <ProductCard key={p.id} product={p} />
                    ))}
                </div>
            )}
        </div>
    );
}
